module.exports = __webpack_public_path__ + "daf0032b2c537647be27698e59d44837.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-22@2x.png
// module id = 507
// module chunks = 0